module.exports = __webpack_public_path__ + "img/mb.50661c67.png";